import { useFeatureEntitlements } from '@frontegg/react';
import {
  BarChartSquare02,
  CheckSquareBroken,
  ClockStopwatch,
  Inbox01,
} from '@insight-health-ai/roseate/icons';
import { useGetCurrentPractitioner } from 'src/hooks/settings';
import type { AppNavMenu } from '..';

export const useTasksV2NavMenus = (): AppNavMenu[] => {
  const { isEntitled } = useFeatureEntitlements('tasks-v2');
  const { isAdmin, isSuperAdmin } = useGetCurrentPractitioner();
  if (!isEntitled) return [];

  const showAdminScreens = isAdmin || isSuperAdmin;

  return [
    {
      path: '/tasks-v2/queue',
      title: 'Tasks',
      icon: <CheckSquareBroken />,
      submenu: [
        {
          path: '/tasks-v2/queue',
          title: 'Queue',
          icon: <Inbox01 />,
        },
        ...(showAdminScreens
          ? [
              {
                path: '/tasks-v2/analytics',
                title: 'Insights',
                icon: <BarChartSquare02 />,
              },
              {
                path: '/tasks-v2/sla',
                title: 'SLA targets',
                icon: <ClockStopwatch />,
              },
            ]
          : []),
      ],
    },
  ];
};
